export default "__VITE_ASSET__BCoJBACz__"